<template>
  <a-form :form="form" @submit="handleSubmit" style="width: 96%;margin: 0 auto">
    <a-form-item>
      <span class="spanOne">{{ $tc('lang.payType.System_Order_Nr') }}：</span>
      <span>{{ data.orderId }}</span>
    </a-form-item>
    <a-form-item>
      <span class="spanOne">
        {{ $tc('lang.payType.Order_Type') }}:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span class="spanTow">{{ orderType }}</span>
    </a-form-item>
    <a-form-item>
      <span class="spanOne">
        {{ $tc('lang.payType.Report_Type') }}:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span class="spanOne">{{ reportType }}</span>
    </a-form-item>
    <a-form-item>
      <span class="spanOne"
        >{{ $tc('lang.payType.Amount') }}：&nbsp;&nbsp;&nbsp;&nbsp;</span
      >
      <span class="spanThree">
        {{ data.payDay === null ? 0 : data.payDay
        }}{{ $tc('lang.payType.MD') }}（¥{{
          data.payRmbMoney === null ? 0 : data.payRmbMoney
        }}/${{ data.payUsbMoney }}）</span
      >
    </a-form-item>
    <a-form-item>
      <span class="spanOne"
        >{{ $tc('lang.payType.Optional_package') }}:
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
      >
      <a-checkbox-group @change="onChange">
        <a-checkbox
          v-for="(item, index) in data.setmealpays"
          :key="index"
          :value="index"
          :disabled="item.disabled"
          ><span class="spamFour"
            >{{ Chinese ? item.setmealName : item.setmealEnname }}<br />（{{
              $tc('lang.payType.Surplus')
            }}{{ item.setmealCount }}{{ $tc('lang.payType.MD') }}）</span
          ></a-checkbox
        >
      </a-checkbox-group>
    </a-form-item>
    <a-form-item style="text-align: center">
      <a-button class="payButton" @click="action()" :disabled="disabled">{{
        $tc('lang.payType.Submit')
      }}</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
export default {
  name: 'renmPay',
  data() {
    return {
      // 1-微信，2-支付宝，3-线下
      value: 0,
      disabled: false,
      form: this.$form.createForm(this),
      data: {
        orderId: 1234,
      },
      // 1-套餐，2-订单
      type: '1',
      htmls: '',
      user: {},
      orderType: '',
      reportType: '',
      userData: JSON.parse(sessionStorage.getItem('user')) || {},
      checkdArr: [],
      total: 0,
      Chinese: '',
    };
  },
  created() {
    this.queryOederById();
    // 获取用户sessionStorage信息
    if (sessionStorage.getItem('user') !== null) {
      this.user = JSON.parse(sessionStorage.getItem('user')) || {};
    }
    //判断当前语言环境
    if (this.$i18n.locale === 'zh-CN') {
      this.Chinese = true;
    } else if (this.$i18n.locale === 'en-US') {
      this.Chinese = false;
    }
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
  },
  watch: {
    language() {
      if (this.language === 'zh-CN') {
        this.Chinese = true;
      } else if (this.language === 'en-US') {
        this.Chinese = false;
      }
    },
  },
  methods: {
    //数据提交
    handleSubmit(e) {
      console.log(e);
      event.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('=====数据====', values);
        }
      });
    },
    // 选择支付套餐
    onChange(value) {
      this.total = 0;
      const setmealpays = this.data.setmealpays;
      const payDay = this.data.payDay;
      //每次onChange都初始化移除disabled
      setmealpays.forEach(res => {
        delete res.disabled;
      });
      //计算所选人天的总数,value为所选套餐的下标数组
      this.checkdArr = value.map(res => {
        this.total += setmealpays[res].setmealCount;
        return setmealpays[res];
      });
      //若所选人天的总数>=等待支付金额
      if (this.total >= payDay) {
        //设置所选项的disabled为false
        value.forEach(res2 => {
          setmealpays[res2].disabled = false;
        });
        this.data.setmealpays = setmealpays.map(res3 => {
          //设置非所选项的disabled为true
          if (res3.disabled != false) {
            res3.disabled = true;
          }
          return res3;
        });
      } else {
        //若所选人天的总数<等待支付金额，移除所有disabled
        this.data.setmealpays = setmealpays.map(res => {
          delete res.disabled;
          return res;
        });
      }
    },
    // 查询数据
    queryOederById() {
      this.$nextTick(() => {
        this.$http
          .post('/hzwmj/person-setmealuse/getPayInfo', {
            id: this.$route.query.id,
          })
          .then(data => {
            if (data.code === 200) {
              const buyData = data.data;
              this.data = buyData;
              // 1（中期验货）、2（尾期验货）、3（面料验货）、4（质量验厂）、5（监装）
              this.orderType = this.getOrderType(buyData.orderType);
              this.reportType = this.getReportType(buyData.reportType);
              console.log('=====buyData=====', buyData);
            } else if (data.code === 900) {
              this.$message.error(data.msg);
            } else {
              this.$message.error('系统异常');
            }
          })
          .catch(() => {});
      });
    },
    // 立即付款
    action() {
      this.$nextTick(() => {
        let payDay = this.data.payDay;
        if (this.checkdArr.length == 0) {
          this.$message.error('请选择套餐进行支付');
          return false;
        } else if (this.total < payDay) {
          this.$message.error('所选套餐不足支付');
          return false;
        }
        let surplus = 0;
        const data = this.checkdArr.map(res => {
          res.personId = this.userData.id || '';
          res.setmealId = res.id || '';
          if (payDay - res.setmealCount >= 0) {
            surplus = res.setmealCount;
            payDay = payDay - res.setmealCount;
          } else {
            surplus = payDay;
          }
          res.setmealUsecount = surplus;
          res.setmealUseorder = this.data.orderId || '';
          return res;
        });
        this.$http
          .post('/hzwmj/person-setmealuse/addSetMealUseRecord', { data })
          .then(data => {
            if (data.code === 200) {
              if (data.data) {
                this.$message.success('付款成功');
                setTimeout(() => {
                  this.$router.go(-1); //返回上一层
                }, 1000);
              }
            } else if (data.code === 900) {
              this.$message.error(data.msg);
            } else {
              this.$message.error('系统异常');
            }
          })
          .catch(() => {});
      });
    },
    //设置订单类型
    getOrderType(res) {
      if (this.Chinese == true) {
        switch (res) {
          case '1':
            return '中期验货';
          case '2':
            return '尾期验货';
          case '3':
            return '面料验货';
          case '4':
            return '质量验厂';
          case '5':
            return '监装';
        }
      } else {
        switch (res) {
          case '1':
            return 'Mid Term Inspection';
          case '2':
            return 'Final Inspection';
          case '3':
            return 'Fabric Inspection';
          case '4':
            return 'Factory Assessment';
          case '5':
            return 'Loading Supervision';
        }
      }
    },
    getReportType(res) {
      if (this.Chinese == true) {
        switch (res) {
          case '1':
            return '中文报告';
          case '2':
            return '英文报告';
        }
      } else {
        switch (res) {
          case '1':
            return 'Chinese Report';
          case '2':
            return 'English Report';
        }
      }
    },
  },
};
</script>

<style scoped>
/*中间的过度的横线*/
.link-top {
  width: 100%;
  height: 1px;
  border-top: solid #acc0d8 1px;
}
.spanOne {
  line-height: 25px;
  font-size: 16px;
  color: #50688c;
}
.spanTow {
  font-weight: 800;
  font-size: 20px;
}
.spanThree {
  height: 64px;
  line-height: 64px;
  font-size: 24px;
  color: #158be4;
  font-weight: 600;
}
.spamFour {
  color: #8492a6;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  min-width: 170px;
}
.payButton {
  background: #ff8d1a;
  border: 1px solid #ff8d1a;
  color: rgb(255, 255, 255);
  width: 250px;
  height: 40px;
}
.ant-checkbox-wrapper {
  margin-left: 8px;
}
</style>
